"use client";
import { Accordion2, H1, H4, P, UniversalLink } from "@template/components";
import * as S from "./styles.ts";

interface IFaqAccordionSectionComponentProps {
  header?: {
    title: string;
    subtitleWithLinks?: {
      content: string;
      href?: string;
    }[];
    subtitle?: string;
  };
  subtitle?: string;
  accordionItems?: {
    title: string;
    content: string;
  }[];
}

const FaqAccordionSectionComponent = ({
  header,
  accordionItems,
  subtitle = "Related FAQ's",
}: IFaqAccordionSectionComponentProps) => {
  return (
    <S.FaqAccordionWrapper>
      <S.FaqAccordionContainer>
        <S.HeaderContainer>
          <H1 as="h2">{header?.title}</H1>
          {header?.subtitle && <P>{header.subtitle}</P>}
          {header?.subtitleWithLinks && (
            <P>
              {header.subtitleWithLinks.map((item, index) => {
                if (item.href === undefined) {
                  return <span key={index}>{item.content}</span>;
                } else if (item.href !== undefined) {
                  return (
                    <UniversalLink
                      key={index}
                      href={item.href}
                    >
                      {item.content}
                    </UniversalLink>
                  );
                }
              })}
            </P>
          )}
        </S.HeaderContainer>
        <S.AccordionContainer>
          {subtitle && <H4 as="h2">{subtitle}</H4>}
          {accordionItems && (
            <Accordion2
              items={accordionItems}
              activeColor="primary"
              whiteBackground={true}
            />
          )}
        </S.AccordionContainer>
      </S.FaqAccordionContainer>
    </S.FaqAccordionWrapper>
  );
};

export default FaqAccordionSectionComponent;

export const options = [
  {
    description: "",
    displayName: "FaqAccordionSectionComponent",
    methods: [],
    props: {
      header: {
        required: false,
        flowType: {
          name: "signature",
          type: "object",
          raw: "{\n  title: string;\n  subtitleWithLinks?: {\n    content: string;\n    href?: string;\n  }[];\n  subtitle?: string;\n}",
          signature: {
            properties: [
              {
                key: "title",
                value: {
                  name: "string",
                  required: true,
                },
              },
              {
                key: "subtitleWithLinks",
                value: {
                  name: "Array",
                  elements: [
                    {
                      name: "signature",
                      type: "object",
                      raw: "{\n  content: string;\n  href?: string;\n}",
                      signature: {
                        properties: [
                          {
                            key: "content",
                            value: {
                              name: "string",
                              required: true,
                            },
                          },
                          {
                            key: "href",
                            value: {
                              name: "string",
                              required: false,
                            },
                          },
                        ],
                      },
                    },
                  ],
                  raw: "{\n  content: string;\n  href?: string;\n}[]",
                  required: false,
                },
              },
              {
                key: "subtitle",
                value: {
                  name: "string",
                  required: false,
                },
              },
            ],
          },
        },
        description: "",
      },
      accordionItems: {
        required: false,
        flowType: {
          name: "Array",
          elements: [
            {
              name: "signature",
              type: "object",
              raw: "{\n  title: string;\n  content: string;\n}",
              signature: {
                properties: [
                  {
                    key: "title",
                    value: {
                      name: "string",
                      required: true,
                    },
                  },
                  {
                    key: "content",
                    value: {
                      name: "string",
                      required: true,
                    },
                  },
                ],
              },
            },
          ],
          raw: "{\n  title: string;\n  content: string;\n}[]",
        },
        description: "",
      },
    },
  },
];
